/**
 * @ignore
 *
 * @param str Base64 string with URL-safe alphabet as described
 * in https://datatracker.ietf.org/doc/html/rfc4648#section-5, either
 * padded or unpadded.
 * @returns typed array of the decoded data
 */
export function decode(str: string): Uint8Array {
    const urlEncodedStr = str.replace(/_/g, "/").replace(/-/g, "+")
    const binStr = atob(urlEncodedStr)
    return Uint8Array.from(binStr, (c) => c.charCodeAt(0))
}

/**
 * @ignore
 *
 * @param data data to Base64-encode
 * @param urlSafe if false
 * @returns Base64-encoded string with URL-safe alphabet as described
 * in https://datatracker.ietf.org/doc/html/rfc4648#section-5, unpadded
 * as to make it safe to include in URLs without further processing.
 */
export function encode(data: Uint8Array, urlSafe: boolean = true): string {
    const binStr = String.fromCharCode(...data)
    const str = btoa(binStr)
    if (urlSafe) {
        return str.replace(/\//g, "_").replace(/\+/g, "-").replace(/=/g, "")
    } else {
        return str
    }
}
